// frontend/src/pages/auth/SlotBlockedNotice.tsx
//
// 🔒 THIS IS THE ONLY WAY BACK IN. "Sign out everywhere" requires being signed
// in, which a blocked person is not. Without the takeover button here, every
// lost handset becomes a phone call to the owner — which is exactly why option 1
// was chosen on 2026-09-04 (spec D2).
//
// The password has already been checked by the time this renders: the server
// refused with 409 AFTER verifying the credentials. That is the same proof any
// sign-in gets, which is what makes the self-service takeover safe.
//
// 🔒 PLATFORM ONLY (P3). No product vocabulary anywhere a person can read —
// this file is copied to Sun Stellar unchanged.

import { Loader2, Smartphone, Monitor } from 'lucide-react';
import { agoWords } from '../../utils/agoWords';

export interface SlotHolder {
  label: string;
  clientVersion: string;
  networkName: string | null;
  lastSeenAt: string;
}

export interface SlotBlock {
  channel: 'web' | 'apk';
  holder: SlotHolder;
  selfServiceTakeover: boolean;
}

export function SlotBlockedNotice({
  block,
  onTakeover,
  busy,
}: {
  block: SlotBlock;
  onTakeover: () => void;
  busy: boolean;
}) {
  const isPhone = block.channel === 'apk';
  const word = isPhone ? 'phone' : 'browser';
  const Icon = isPhone ? Smartphone : Monitor;

  return (
    <div className="mb-4 rounded-lg border p-4" style={{ borderColor: '#f0c4bf', background: '#fff0ee' }}>
      <p className="mb-3 text-sm font-semibold" style={{ color: '#b6403f' }}>
        Your account is already open on another {word}.
      </p>

      <div className="mb-3 flex items-start gap-3 rounded-lg border border-slate-200 bg-white p-3">
        <Icon className="mt-0.5 h-4 w-4 text-slate-500" />
        <div className="min-w-0">
          <p className="truncate text-sm font-medium text-slate-900">{block.holder.label}</p>
          <p className="text-xs text-slate-600">{block.holder.clientVersion}</p>
          <p className="text-xs text-slate-500">
            {[block.holder.networkName, `last used ${agoWords(block.holder.lastSeenAt)}`]
              .filter(Boolean)
              .join(' · ')}
          </p>
        </div>
      </div>

      <p className="mb-3 text-xs text-slate-600">One {word} at a time.</p>

      {block.selfServiceTakeover ? (
        <>
          <button
            type="button"
            onClick={onTakeover}
            disabled={busy}
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-medium text-white disabled:opacity-50"
            style={{ background: '#bf4846' }}
          >
            {busy && <Loader2 className="h-4 w-4 animate-spin" />}
            Sign out that {word} and continue here
          </button>
          <p className="mt-2 text-xs text-slate-500">
            Your password was correct, so we know it is you. That {word} is signed out, this one takes
            the slot, and your administrator is told.
          </p>
        </>
      ) : (
        <p className="text-xs text-slate-600">
          Ask your administrator to sign that {word} out for you.
        </p>
      )}
    </div>
  );
}
